import React from 'react';
import { PostsEditor } from '../editors/PostsEditor';
import { useSonTranslation } from '../../../../translation/useSonTranslation';
import { PostFirst, PostFirstTypes } from '../Post.types';
import { ButtonType } from '../../../../types/ButtonType';
import { Icons } from '../../../../components/atoms/SVG';
import { ContentHeadline } from '../../ContentHeadline';
import Btn, { BtnModifier } from '../../../../components/molecules/Btn';
import { TooltipPlacement } from '../../../../components/atoms/Tooltip';
import IForm from '../../../../types/IForm';

type PostReplyFormProps = {
  type: PostFirstTypes;
  post: PostFirst;
  setCurrentForm: (newState: IForm | undefined) => void;
};

export function PostReplyForm({ type, post, setCurrentForm }: PostReplyFormProps) {
  const { t } = useSonTranslation('Posts');

  return (
    <div className="posts__post-reply">
      <div className="posts__interactions-close-reply">
        <ContentHeadline title={t(`default.heading.writeReply.${type}`)} hierarchy={4} />
        <Btn
          href={`#reply-button-${post.id}`}
          modifier={[BtnModifier.MINOR_ACTION, BtnModifier.TRANSPARENT, BtnModifier.ACTIVE]}
          onClick={() => setCurrentForm(undefined)}
          tooltipPlacement={TooltipPlacement.TOP}
          type={ButtonType.BUTTON}
          svgSpriteId={Icons.DECLINE_CROSS}
          text={t(`default.replyClose.${type}`)}
          titleText={t(`default.replyClose.${type}`)}
          hiddenText
        />
      </div>
      <div className="posts__reply-editor-container">
        <PostsEditor form={post.replyForm} type="reply" autoFocus />
      </div>
    </div>
  );
}
